import { render, staticRenderFns } from "./CSCateRootEdit.vue?vue&type=template&id=32ea7ed0&scoped=true"
import script from "./CSCateRootEdit.vue?vue&type=script&lang=js"
export * from "./CSCateRootEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ea7ed0",
  null
  
)

export default component.exports